<div *ngIf="error" class="alert alert-danger">{{ error }}</div>
<div *ngIf="success" class="alert alert-success">{{ success }}</div>

<div i18n class="current-email">
  Your current email is <span class="email">{{ user.email }}</span>.
  It is never shown to the public.
</div>

<div i18n class="pending-email" *ngIf="user.pendingEmail">
  <span class="email">{{ user.pendingEmail }}</span> is awaiting email verification
</div>

<form role="form" class="change-email" (ngSubmit)="changeEmail()" [formGroup]="form" *ngIf="user.pluginAuth === null">

  <div class="form-group">
    <input
      type="email" id="new-email" i18n-placeholder placeholder="New email" class="form-control"
      formControlName="new-email" [ngClass]="{ 'input-error': formErrors['new-email'] }"
    >
    <div *ngIf="formErrors['new-email']" class="form-error">
      {{ formErrors['new-email'] }}
    </div>
  </div>

  <div class="form-group">
    <my-input-toggle-hidden formControlName="password"
                            id="password"
                            i18n-placeholder placeholder="Current password"
                            [ngClass]="{ 'input-error': formErrors['password'] }"
                            autocomplete="current-password"></my-input-toggle-hidden>
    <div *ngIf="formErrors['password']" class="form-error">
      {{ formErrors['password'] }}
    </div>
  </div>

  <input type="submit" i18n-value value="Change email" [disabled]="!form.valid">
</form>
